import { Stack } from '@mui/material';
import FileDetailMobile from './DetailMobile';
import { useDimension } from 'hooks/useDimension';
import { EditFilesPage } from '../Admin/FilesPage/Edit';

export function FileDetail() {
  const { width } = useDimension();
  const isMobile = width <= 765;
  return <Stack width={'100%'}>{isMobile ? <FileDetailMobile /> : <EditFilesPage />}</Stack>;
}
